import styled from 'styled-components';

import { Color } from '../../../constants/Colors';
import { Typography } from '../../../constants/Typographies';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const QuoteLine = styled.span`
  ${Typography.XXL}
  color: ${Color.CLOUD_BURST};
`;

export const QuoteAuthor = styled.span`
  ${Typography.XS};
  color: ${Color.CLOUD_BURST};
`;
